























































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import TaskListBase from "./TaskListBase";

	@Component
	export default class TaskList extends TaskListBase {

		created() {
			super.initializeRights('CON_Task_Create', 'CON_Task_Delete', 'CON_Task_Read', 'CON_Task_Update');
            super.setTimer(this.$store.state.pageTimer);
			super.created();
            this.setDeleteMessage(this.$t('task.messageQuestionMain').toString(), this.$t('task.messageQuestionMain2').toString(), this.$t('task.messageQuestionMain3').toString());

			super.setDetailName('TaskDetail');
        };

        moreActionIconColorDelegate() {
            return this.moreActionAllowDelegate() ? "green" : "";
        }

        changeTags(items: any, idLast: number) {
            this.changeTagsBase(items, idLast);
		}

        goBackDetailModal(item: any): void {
            this.goBackDetailModalBase(item, this.tableData);
        }

		timer = 0;
		mounted() {
			this.timerHandle = setInterval(() => {
				this.timerRefresh();				
            }, this.timerSecondRefresh);

		}

		beforeDestroy() {
			clearInterval(this.timerHandle);
        }

        goToReciver(item: any): void {
            this.$router.push({ name: 'ReceiverDetail', params: { id: item.id.toString() }, query: { id: item.id.toString() } });
        }

		selectRows(items: any) {
			this.selectRowsBase(items);
		}

		showAllertToDeleteClick(itemsSelected: any) {
			//this.showAllertToDeleteClickBase(itemsSelected);
            this.countToRemove = itemsSelected != undefined ? ((typeof itemsSelected === 'number') ? 1 : (itemsSelected as Array<any>).length) : 1;
            if (this.$store.state.askBeforeDelete) {

                super.showAlertBeforeActionClickBase(itemsSelected, super.prepareRemoveMessage(), true);
            }
            else {
                this.itemsSelected = itemsSelected;
                this.callAction(true,false, false);
            }
		}

        showAllertToDelegateClick(itemsSelected: any) {    
            this.itemsSelected = itemsSelected;
            this.countToRemove = itemsSelected != undefined ? ((typeof itemsSelected === 'number') ? 1 : (itemsSelected as Array<any>).length) : 1;
            this.showAlertModalById('alertModalIdAllowDelegate');
			//this.showAllertBeforeActionClickBase(itemsSelected, this.$t('task.messageDelegate').toString(), false, false, true);
		}

        showAllertToStopClick(itemsSelected: any) {
            this.itemsSelected = itemsSelected;
            this.countToRemove = itemsSelected != undefined ? ((typeof itemsSelected === 'number') ? 1 : (itemsSelected as Array<any>).length) : 1;
            this.showAlertModalById('alertModalIdAllowStop');
			//this.showAllertBeforeActionClickBase(itemsSelected, this.$t('task.messageStop').toString(), false, true, false);
		}

		loadFilters(value: any) { super.loadFilters(value); };
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) { super.detailClick(elementId); };
		deleteClick(elementId: any) { super.deleteClick(elementId); }


	};
